<template>
    <main class="main">
        <div class="main__page">
            <div class="card__header">
                <h2 class="main-title">
                    {{ $t('common.settings') }}
                </h2>
            </div>
            <div class="card">
                <div class="card__detail">
                    <button class="btn dashboard_button" @click="toggleCloseResetModel()">
                        Ripristina Dati
                    </button>
                </div>
            </div>
        </div>
        <div class="main__page">
            <div class="card__header">
                <h2 class="main-title">
                    Informazioni
                </h2>
            </div>
            <div class="card">
                <div class="card__detail">
                    <strong>Spazio utilizzato</strong><br>
                    <div v-for="s in dataSpace" v-bind:key="s.name">
                        <span style="font-weight: bold;">{{s.name}}:</span> {{s.mb}}Mb
                    </div>
                </div>
            </div>
        </div>
        <confirm-modal v-model="modalResetOpen" v-bind:title="$t('settings.confirm.title')" v-bind:text="$t('settings.confirm.message')" @result="closeResetModal($event)"></confirm-modal>
        <alert-modal v-model="modalAlertResetOpen" v-bind:title="$t('settings.alert.title')" v-bind:text="$t('settings.alert.message')"></alert-modal>
    </main>
</template>
<script>
    import ConfirmModal from "../components/ConfirmModal";
    import AlertModal from "../components/AlertModal";
    import localForage from 'localforage';

    export default {
        name: 'settings',
        data() {
            return {
                modalResetOpen: false,
                modalAlertResetOpen: false,
                dataSpace: []
            }
        },
        mounted() {
            this.init();
        },
        components: {
            AlertModal,
            ConfirmModal
        },
        methods: {
            closeResetModal(result) {
                if(result) {
                    this.helpers.clearAllData(() => {
                        this.modalResetOpen = false;
                        this.modalAlertResetOpen = true;
                    })
                }
            },
            toggleCloseResetModel() {
                this.modalResetOpen = !this.modalResetOpen;
            },
            init() {
                let pSize = [];
                let pKeys = [];
                localForage.keys().then(keys => {
                    keys.map(k => {
                        pKeys.push(k);
                        pSize.push(localForage.getItem(k));
                    });
                    Promise.all(pSize).then(res => {
                        this.dataSpace = [];
                        res.map((data, index) => {
                            let mb = (+(JSON.stringify(data).length / 1024) / 1024).toFixed(2);
                            this.dataSpace.push({
                                'name': pKeys[index],
                                'mb': mb
                            })
                        });
                        console.log(this.dataSpace);
                        /*let kb = JSON.stringify(res).length;
                        if(kb > 0) {
                            this.kb = (+(kb / 1024) / 1024).toFixed(2);
                            let r = (this.kb / 5) * 100;
                            this.perc = (r == 0) ? 1 : r.toFixed(0);
                        }
                        return kb.toFixed(0);*/
                    });
                });
            }
        }
    }
</script>
